export { default as tooltipify } from "./tooltipify";
import { default as _Tooltip } from "./tooltip";
export var Tooltip = _Tooltip;
export default Tooltip;
//# sourceMappingURL=index.js.map